import { useState, useEffect } from 'react'
import { API_BASE_URL } from '../../config/api'
import './VerifyEmail.css'

export default function VerifyEmail() {
  const [status, setStatus] = useState('verifying') // verifying, success, error
  const [message, setMessage] = useState('Verifying your email...')
  const [redirectPath, setRedirectPath] = useState('/')
  
  useEffect(() => {
    const verify = async () => {
      // Get token from URL
      const params = new URLSearchParams(window.location.search)
      const token = params.get('token')
      const redirect = params.get('redirect_to')
      
      if (redirect) {
        setRedirectPath(redirect)
      }
      
      if (!token) {
        setStatus('error')
        setMessage('Invalid verification link. No token found.')
        return
      }

      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/auth/verify`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ token })
        })

        const data = await response.json()

        if (!response.ok) {
          throw new Error(data.error || 'Verification failed')
        }

        setStatus('success')
        setMessage('Email verified successfully! Opening the Rift...')
        
        // Auto-redirect after success
        setTimeout(() => {
          window.location.href = redirect || '/'
        }, 2000)

      } catch (error) {
        setStatus('error')
        setMessage(error.message)
      }
    }

    verify()
  }, [])

  return (
    <div className="verify-email-page">
      <div className="verify-email-container">
        <div className="verify-email-logo-container">
          <img src="/riftchesslogohorizontalfinal.png" alt="RiftChess" className="verify-email-logo" />
        </div>
        
        <h2 className="verify-email-title">Email Verification</h2>
        
        <div className="verify-email-content">
          {status === 'verifying' && (
            <div className="loading-spinner"></div>
          )}
          
          {status !== 'verifying' && (
            <div className="verify-status-icon">
              {status === 'success' ? '✅' : '❌'}
            </div>
          )}

          <p className={`verify-message ${status}`}>
            {message}
          </p>

          {status !== 'verifying' && (
            <button 
              onClick={() => window.location.href = redirectPath}
              className="verify-action-btn"
            >
              {status === 'success' ? 'Continue' : 'Go to Dashboard'}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
